/* eslint-disable import/prefer-default-export */
import { postWithOutAuth } from './http.service';
import { LOG_TO_AWS_CLOUDWATCH_URL } from './url.service';

export const logToConsole = (logData: any, logMessage: any, level: string) => {
  const consoleMessage = `[${level}] ${logMessage}`;

  switch (level.toUpperCase()) {
    case 'ERROR':
      console.error(consoleMessage, logData);
      break;
    case 'WARN':
    case 'WARNING':
      console.warn(consoleMessage, logData);
      break;
    case 'DEBUG':
      console.debug(consoleMessage, logData);
      break;
    case 'INFO':
    default:
      console.log(consoleMessage, logData);
      break;
  }
};

export const logsToAwsCloudWatch = (body: any) => {
  const msg = body?.logMessage || 'No log message provided';
  const level = body?.level || 'INFO';
  body.href = window?.location?.href;

  logToConsole(body?.logData, msg, level);
  postWithOutAuth(LOG_TO_AWS_CLOUDWATCH_URL(), body);
};

export const logToCloudWatch = (message: string, body: object, level: string = 'INFO') => {
  logsToAwsCloudWatch({
    logMessage: message,
    logData: body,
    level
  });
};
